import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query"
import { getLabels } from "../services/label";

import { setLabels } from "../redux/slices/cvSlice";

export const useFetchCVsLabels = ({ enabled, callback }) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["cvsLabels"],
    queryFn: () => getLabels().then(data => {
      dispatch(setLabels(data || []));
      return data || [];
    }),
    enabled,
  });
}